import Logger from './logger';

const log = new Logger();

/**
 * getRootDomain:
 * Returns the root domain of a given URL
 *
 * @param hostname
 * @returns {string}
 */
export default (hostname) => {
  const parts = hostname.split('.');
  const rootDomain = parts.length === 3 ? `${parts[1]}.${parts[2]}` : hostname;
  log.info('help.getRootDomain', rootDomain);
  log.debug({
    category: 'helpers',
    message: 'getRootDomain',
    data: { rootDomain }
  });

  return rootDomain;
};
